<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <span>
    <!-- support button Anfang -->
    <v-menu :close-on-content-click="false" v-model="showMenu">
      <template #activator="{ on: menu }">
        <v-tooltip bottom>
          <template #activator="{ on: tooltip }">
            <v-btn flat icon v-on="{ ...tooltip, ...menu }" color="#8ACAC1" style="margin-top: -3px">
              <v-icon color="#8ACAC1" small>add_box</v-icon>
            </v-btn>
          </template>
          <span>{{'MISSING_BALANCE_TOOLTIP' | translate}}</span>
        </v-tooltip>
      </template>
      <v-card width="600px" flat>
          <v-card color="blue" class="title pa-2 pl-3 font-weight-thin white--text text-xs-left mb-2">
            {{'MISSING_BALANCE_TITLE' | translate}}
          </v-card>
          <v-card flat>
            <ContactForm_Support_Jahresabschluss ref="form" @cancel="closeMenu" :title="title" :balance="balance"/>
          </v-card>
        </v-card>
    </v-menu>
  </span>
  <!--Button ende -->
</template>

<script>
  import Vue from 'vue'
  import ContactForm_Support from './../widgets/ContactForm_Support'
  import ContactForm_Support_Jahresabschluss from './../widgets/ContactForm_Support_Jahresabschluss'

  export default {
    name: 'BtnSupport',
    components: {ContactForm_Support, ContactForm_Support_Jahresabschluss},
    props: ['balance', 'title'],
    watch: {
      showMenu(val) {
        this.showMenu = val
        if (val) {
          this.$refs.form.myUpdate(this.balance, this.title)
        }
      }
    },
    methods: {
      open: function () {
      },
      closeMenu: function () {
        Vue.prototype.$api.debug('closeMenu')
        this.showMenu = false
      },
      onLogin(login) {
        this.isLogin = !login
      }
    },
    data() {
      return {
        on: {},
        showMenu: false,
        isLogin: true
      }
    },
    mounted() {
      // this.isLogin = Vue.prototype.$api.getCredentials() !== null
    },
    created() {
      Vue.prototype.$eventHub.$on('OnLogin', this.onLogin)

    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnLogin', this.onLogin)
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widgets/BtnSupportJahresabschluss.vue